/**
 * Safety Components Index
 *
 * Exports all safety-related components for the Moderation & Safety infrastructure.
 *
 * Components:
 * - CrisisBanner: Persistent help banner (shown on Home/Results/History)
 * - CrisisResourcesModal: Full resources modal with tap-to-call
 * - TosModal: Terms of Service acceptance modal
 * - ConcernFlagModal: "I'm Concerned" user reporting modal
 * - SafetyModalsManager: Central coordinator for all safety modals
 *
 * Created: 2025-12-18
 * Phase: Moderation & Safety Infrastructure (Week 1 + Week 2)
 */

// Week 1 components
export { CrisisBanner } from './CrisisBanner';
export type { CrisisBannerProps } from './CrisisBanner';

export { CrisisResourcesModal } from './CrisisResourcesModal';
export type { CrisisResourcesModalProps } from './CrisisResourcesModal';

// Week 2 components
export { TosModal } from './TosModal';
export type { TosModalProps } from './TosModal';

export { ConcernFlagModal } from './ConcernFlagModal';
export type { ConcernFlagModalProps, ConcernReason } from './ConcernFlagModal';

export { SafetyModalsManager } from './SafetyModalsManager';
export type { SafetyModalsManagerProps } from './SafetyModalsManager';

// Phase 2.5 components (Crisis Practitioner Integration)
export { CrisisPractitionerPrompt } from './CrisisPractitionerPrompt';
export type { CrisisPractitionerPromptProps } from './CrisisPractitionerPrompt';

// Phase 3 components (Crisis Detection Feedback Loop)
export { CrisisDetectionFeedbackModal } from './CrisisDetectionFeedbackModal';
export type {
  CrisisDetectionFeedbackModalProps,
  CrisisDetectionFeedbackData,
} from './CrisisDetectionFeedbackModal';
export type { FalsePositiveCategory } from '../../lib/analytics/events/safety';
